import { useState } from 'react';

import {
  ZoomBoundary,
  ZoomedRange,
  ZoomProps,
  ZoomStateReturnType,
} from '../../types';

type UseReactStateStrategyArgs = Pick<ZoomProps, 'onZoom' | 'onResetZoom'>;

export const useZoomState = ({
  onZoom,
  onResetZoom,
}: UseReactStateStrategyArgs): ZoomStateReturnType => {
  const [hasZoomed, setHasZoomed] = useState(false);
  const [zoomedRange, setZoomedRange] = useState<ZoomedRange>({
    from: undefined,
    to: undefined,
  });

  const persistZoomState = (fromValue: ZoomBoundary, toValue: ZoomBoundary) => {
    setHasZoomed(true);
    setZoomedRange({ from: fromValue, to: toValue });
    onZoom?.(fromValue, toValue);
  };

  const resetZoomState = () => {
    setHasZoomed(false);
    onResetZoom?.();
    setZoomedRange({ from: undefined, to: undefined });
  };

  return {
    zoomedRange,
    persistZoomState,
    hasZoomed,
    resetZoomState,
  };
};
